import { Spin } from 'antd';

interface SpinProp {
  size?: 'small' | 'large';
  type?: SpinTypes;
}

export enum SpinTypes {
  INSIDE = 'inside',
  FULL_SCREEN = 'fullscreen',
  TAB_INSIDE = 'tabInside',
  CENTER = 'center',
}

export const SpinLoader = ({ size = 'large', type = SpinTypes.INSIDE }: SpinProp) => {
  const classStyle = {
    [SpinTypes.INSIDE]: 'absolute top-0 left-0 ml-[50%] mt-[25%]',
    [SpinTypes.TAB_INSIDE]: 'top-0 left-0 ml-[50%] mt-[10%] h-[200px]',
    [SpinTypes.CENTER]: 'flex items-center justify-center h-full w-full',
    [SpinTypes.FULL_SCREEN]: 'fixed inset-0 flex items-center justify-center bg-white/70 z-50',
  }[type];

  return (
    <div className={classStyle}>
      <Spin size={size} className="page-spinner" />
    </div>
  );
};
